var exports = {
  "tb": "UserProfileModal.module__noteTextarea___T01VVX",
  "CR": "UserProfileModal.module__modalRoot___T01VVX",
  "eF": "UserProfileModal.module__userInfo___T01VVX",
  "hR": "UserProfileModal.module__userInfoHeader___T01VVX",
  "hA": "UserProfileModal.module__userInfoHeaderDesktop___T01VVX",
  "Rn": "UserProfileModal.module__userInfoContent___T01VVX",
  "yn": "UserProfileModal.module__profileDataWarning___T01VVX",
  "S7": "UserProfileModal.module__nameRow___T01VVX",
  "nT": "UserProfileModal.module__userName___T01VVX",
  "a1": "UserProfileModal.module__userTag___T01VVX",
  "Fj": "UserProfileModal.module__usernameRow___T01VVX",
  "hI": "UserProfileModal.module__pronouns___T01VVX",
  "sM": "UserProfileModal.module__srOnly___T01VVX",
  "Li": "UserProfileModal.module__customStatusText___T01VVX",
  "Ef": "UserProfileModal.module__customStatusRow___T01VVX",
  "_z": "UserProfileModal.module__tagBadgeRow___T01VVX",
  "U3": "UserProfileModal.module__badgesWrapper___T01VVX",
  "ZV": "UserProfileModal.module__userNoteEditor___T01VVX",
  "xu": "UserProfileModal.module__noteLabel___T01VVX",
  "_j": "UserProfileModal.module__noteTextareaBase___T01VVX",
  "CA": "UserProfileModal.module__noteTextareaEditing___T01VVX",
  "EN": "UserProfileModal.module__noteTextareaNotEditing___T01VVX",
  "bs": "UserProfileModal.module__profileContent___T01VVX",
  "EM": "UserProfileModal.module__profileContentHeader___T01VVX",
  "cI": "UserProfileModal.module__bannerContainer___T01VVX",
  "HG": "UserProfileModal.module__bannerMask___T01VVX",
  "_e": "UserProfileModal.module__bannerImage___T01VVX",
  "N1": "UserProfileModal.module__headerContainer___T01VVX",
  "jd": "UserProfileModal.module__headerContainerIdentity___T01VVX",
  "HB": "UserProfileModal.module__userInfoPage___T01VVX",
  "H": "UserProfileModal.module__avatarContainer___T01VVX",
  "fc": "UserProfileModal.module__actionButtonsContainer___T01VVX",
  "hQ": "UserProfileModal.module__contentContainer___T01VVX",
  "sq": "UserProfileModal.module__profileContentWrapper___T01VVX",
  "zL": "UserProfileModal.module__scrollerFullHeight___T01VVX",
  "jT": "UserProfileModal.module__modalContainer___T01VVX",
  "uu": "UserProfileModal.module__actionButtons___T01VVX",
  "iA": "UserProfileModal.module__buttonIcon___T01VVX",
  "ro": "UserProfileModal.module__menuIcon___T01VVX",
  "WB": "UserProfileModal.module__avatarFocusRing___T01VVX",
  "VS": "UserProfileModal.module__tabsWrapper___T01VVX",
  "OT": "UserProfileModal.module__mutualFriendsList___T01VVX",
  "Z8": "UserProfileModal.module__mutualSectionDivider___T01VVX",
  "KF": "UserProfileModal.module__mutualFriendItem___T01VVX",
  "vu": "UserProfileModal.module__active___T01VVX",
  "Qd": "UserProfileModal.module__mutualItemIconFrame___T01VVX",
  "D9": "UserProfileModal.module__mutualFriendInfo___T01VVX",
  "eV": "UserProfileModal.module__mutualFriendName___T01VVX",
  "zD": "UserProfileModal.module__mutualFriendUsername___T01VVX",
  "p$": "UserProfileModal.module__emptyState___T01VVX",
  "Ny": "UserProfileModal.module__mutualGuildIcon___T01VVX",
  "me": "UserProfileModal.module__separator___T01VVX",
  "AI": "UserProfileModal.module__emptyStateIcon___T01VVX",
  "FM": "UserProfileModal.module__decorationOverflow___T01VVX",
};

module.exports = exports;
